// 本地环境配置
module.exports = {
  title: '中国包装联合会',
  baseUrl: 'http://192.168.31.60:20008', // 项目地址
  baseApi: 'http://cpf.bjyyxx.cn/api/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static'
}
